import { Pipe, PipeTransform } from '@angular/core';
import { CollectionNoticePaymentModel } from '@core/models';

@Pipe({
  name: 'paymentDate',
})
export class PaymentDatePipe implements PipeTransform {
  transform(value: string, dataItem: CollectionNoticePaymentModel): string {
    const date = dataItem.paymentDate || 'No especificado';

    return date;
  }
}
